import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

import {
  FacilitatorChat,
  FasilitatorChatProps
} from '../../../components/facilitator/chat';
import {
  FacilitatorChatContext,
  FacilitatorChatContextProps
} from '../../../contexts/facilitator-chat';
import { ChatState } from '../../../types/state/websocket/chat-state';
import { GetPlayerFacilitatorChatHistoryAsync } from '../../../services/players';

export const FacilitatorAndPlayerChat = ({
  onSendMessage = () => {},
  ...props
}: FasilitatorChatProps) => {
  const { gameCode } = useParams();
  const auth = useAuth();

  const { chatHub } = React.useContext(
    FacilitatorChatContext
  ) as FacilitatorChatContextProps;

  const [messages, setMessages] = React.useState<ChatState[]>([]);

  const playerCode = props.item?.id ?? '';

  const getChatHistoryAsync = () => {
    let newChat: ChatState[] = [];
    GetPlayerFacilitatorChatHistoryAsync(gameCode!, playerCode).then(
      (response) => {
        response?.forEach((chat) => {
          newChat.push({
            author: {
              id:
                chat.playerCode === '00000000-0000-0000-0000-000000000000'
                  ? auth?.user?.profile.sub!
                  : chat.playerCode,
              name: chat.playerName,
              avatarUrl: chat.playerAvatar
            },
            timestamp: new Date(chat.sentDateUtc),
            group: 'player-chat',
            text: chat.message
          });
        });
        setMessages(newChat);
      }
    );
  };

  React.useEffect(() => {
    if (!chatHub || !playerCode) return;

    chatHub.on('PrivateChatReceived', (data) => {
      const { senderCode, senderName, senderAvatar, message, sentDateUtc } =
        data;

      if (playerCode === senderCode) {
        const chat = {
          author: {
            id:
              senderCode === '00000000-0000-0000-0000-000000000000'
                ? auth?.user?.profile.sub!
                : senderCode,
            name: senderName,
            avatarUrl: senderAvatar
          },
          timestamp: new Date(sentDateUtc),
          group: 'player-chat',
          text: message
        };
        setMessages((prev) => [...prev, chat]);
      }
    });
  }, [chatHub, playerCode]);

  React.useEffect(() => {
    getChatHistoryAsync();
  }, [playerCode]);

  return (
    <FacilitatorChat
      item={props.item}
      messages={messages}
      onSendMessage={(message) => {
        onSendMessage(message);

        const newMessages = {
          author: {
            id: auth?.user?.profile.sub ?? '',
            name: auth.user?.profile.name ?? '',
            avatarUrl: ''
          },
          timestamp: new Date(),
          group: 'player-chat',
          text: message
        };
        setMessages((prev) => [...prev, newMessages]);
      }}
    />
  );
};
